import { type FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { CampaignConfig } from 'src/common/interfaces/campaigns';
import { useGetUserQuery } from 'src/common/slices';
import { CampaignConfigs } from '../../campaigns.config';
import { checkIfPathMatches } from '../../helpers';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import type { CampaignElementProps } from './campaign-element.types';
export const CampaignElement: FC<CampaignElementProps> = ({
  type
}) => {
  const {
    campaign,
    shouldPromote
  } = useActiveCampaign();
  const {
    pathname
  } = useLocation();
  const {
    data: userDataResponse
  } = useGetUserQuery();
  const userData = userDataResponse?.data;
  const campaignConfig = useMemo<CampaignConfig | null>(() => {
    if (!campaign) {
      return null;
    }
    const config = CampaignConfigs[campaign.name]?.[type];
    if (!config) {
      console.warn(`${type} is not configured for this campaign: ${campaign.name}`);
      return null;
    }
    const {
      pathsToExclude,
      pathsToInclude,
      shouldShow
    } = config;
    const showConditionResolves = !shouldShow || shouldShow(pathname, userData);
    const pathMatches = checkIfPathMatches(pathsToExclude || [], pathsToInclude || [], pathname);
    if (!showConditionResolves || !pathMatches) {
      return null;
    }
    return config;
  }, [campaign, pathname, userData, type]);
  return campaignConfig && shouldPromote ? campaignConfig.renderComponent() : null;
};